import React from 'react';
import PropTypes from 'prop-types';

import { loadStripe } from '@stripe/stripe-js';
import { Elements } from '@stripe/react-stripe-js';

import CheckoutForm from './CheckoutForm';

import SecurityInfo from './SecurityInfo';

const stripePromise = loadStripe(gon.stripe_pk);// eslint-disable-line no-undef

export default function Stripe({
  clientSecret, closeModal, setWaitPayment, currency,
}) {
  const appearance = {
    theme: 'stripe',
  };

  const options = {
    clientSecret,
    appearance,
  };

  return (
    <div className="mt-5 stripe">
      {clientSecret && (
        <>
          <Elements options={options} stripe={stripePromise}>
            <CheckoutForm
              clientSecret={clientSecret}
              closeModal={closeModal}
              setWaitPayment={setWaitPayment}
              currency={currency}
            />
          </Elements>
          <SecurityInfo />
        </>
      )}
    </div>
  );
}

Stripe.propTypes = {
  clientSecret: PropTypes.string.isRequired,
  closeModal: PropTypes.func.isRequired,
  setWaitPayment: PropTypes.func.isRequired,
  currency: PropTypes.string,
};

Stripe.defaultProps = {
  currency: 'USD',
};
